<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      $('title').text(globalConfig.appName);
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #484a4d;
    /* background:  #b6bbbb21; */
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    overflow-y: hidden;
  }



  /**左侧导航菜单图标的右侧距离**/
  .menu-bar-container .el-submenu__title i {
    margin-right: 6px !important;
  }

  .menu-bar-container .el-menu-item i {
    margin-right: 6px !important;
  }

  /**左侧导航菜单图标的大小**/
  .menu-bar-container [class^="kt-icon"], [class*=" kt-icon"] {
    font-size: 24px;
  }

  /**系统图标的大小(仅适用于el-icon，不适用于kt-icon)**/
  .sys-icon {
    font-size: 24px;
  }

  /**左侧导航一级菜单高度**/
  .el-submenu__title {
    height: 55px !important;
    line-height: 55px !important;
    font-size: 16px !important;
  }

  /**左侧导航一级菜单滚动**/
  .menu-bar-container .el-menu {
    overflow-y: auto;
  }

  /**左侧导航二级菜单高度**/
  .menu-bar-container .el-menu-item {
    height: 55px !important;
    line-height: 55px !important;
  }

  /**左侧导航二级菜单滚动**/
  .menu-bar-container .el-menu--inline {
    overflow-x: hidden;
    /*overflow-y: auto;*/
    overflow-y: hidden;
  }

  /**el-dialog弹出大小控制**/
  .el-dialog {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    max-width: calc(100% - 30px);
    max-height: calc(100% - 30px);
  }

  /*fullscreen = true 时 字体模糊问题*/
 .is-fullscreen{
    overflow: revert !important;
  }

  .el-dialog__body {
    overflow: auto;
  }

  .gridMinHeight{
    min-height: 621px !important;
  }

  /*el月份选择不显示年*/
  .monthStyle
  .el-date-picker__header--bordered {
    display: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue